<template>
  <navbar class="fixed-top" v-model="showNavbar" :transparent="false">
    <template v-if="token > ''" slot="navbar-menu-l">
      <div class="genovesa"> COVID <span class="genovesa_small"> &nbsp;&nbsp;&nbsp;(v. 1-4-1)</span> </div>
    </template>

    <template v-else slot="navbar-menu-l">
      <div class="genovesa text-center"> Software pro analýzu sekvenačních dat genomu SARS-CoV-2 od BioVendoru a Bioxsysu
      </div>
    </template>

    <template slot="navbar-menu">
      <!-- <form v-if="token > ''">
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="fas fa-search"></i>
            </div>
          </div>
        </div>
      </form> -->

      <div class="dolu_subject">
        <el-tag v-if="token > ''" type="info" effect="plain" >
            {{ user.f_name }} {{ user.l_name }} - {{ subject.subject }}
          </el-tag>
      </div>

      <ul class="navbar-nav">
        <li class="nav-item" v-if="token > ''">
          <router-link class="nav-link btn-magnify" to="/">
            <i class="nc-icon nc-layout-11 white"></i>
            <p>
              <span class="d-lg-none d-md-block"> </span>
            </p>
          </router-link>
        </li>

        <drop-down v-if="token > '' && false" icon="far fa-bell" tag="li"
                   position="right"
                   direction="none"
                   class="nav-item btn-rotate dropdown">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="far fa-bell nav-icon"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <router-link tag="li" class="dropdown-item" to="#">Action</router-link>
          <router-link tag="li" class="dropdown-item" to="#">Another action</router-link>
          <router-link tag="li" class="dropdown-item" to="#">Something else here</router-link>
        </drop-down>

        <drop-down v-if="token > '' && id_subject > 0" icon="fas fa-hospital" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="fas fa-hospital white"></i>
            <p>
              <span class="d-lg-none d-md-block"> </span>
            </p>
          </a>
          <router-link tag="li" class="dropdown-item" to="/projects/shared">--</router-link>
          <router-link tag="li" class="dropdown-item" to="#" @click="m_notifyVue('top','center','HELLO!!!','red')">Joining an organization</router-link>
          <div class="dropdown-divider"></div>
          <router-link tag="li" class="dropdown-item" to="#" @click="a_logout()">Administration of organizations</router-link>
          <div class="dropdown-divider"></div>
          <router-link tag="li" class="dropdown-item" to="#" @click="a_logout()">Sign out</router-link>
        </drop-down>

        <drop-down v-if="token > '' && id_subject === 0" icon="far fa-hospital" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="far fa-hospital white"></i>
            <p>
              <span class="d-lg-none d-md-block"> </span>
            </p>
          </a>
          <a class="dropdown-item" @click="m_modal_join_subject_(true)">Přiřadit do subjektu</a>
          <router-link tag="li" class="dropdown-item" to="/admin/subjects"> My profile </router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="m_modal_join_subject_(true)">Požádat admina o přiřazení do subjektu</a>
          <a class="dropdown-item" @click="m_modal_join_subject_(true)">Přiřadit se do subjektu kódem</a>

          <router-link tag="li" class="dropdown-item" to="/projects/shared">YYYY</router-link>
          <router-link tag="li" class="dropdown-item" to="#" @click="m_notifyVue('top','center','HELLO!!!','red')">Joining an organization</router-link>
          <div class="dropdown-divider"></div>
          <router-link tag="li" class="dropdown-item" to="#" @click="a_logout()">Administration of organizations</router-link>
          <div class="dropdown-divider"></div>
          <router-link tag="li" class="dropdown-item" to="#" @click="a_logout()">Sign out</router-link>
        </drop-down>

        <drop-down v-if="token > ''" icon="fas fa-user" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="fas fa-user nav-icon"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <!-- <router-link tag="li" class="dropdown-item" to="/admin/my_profile"> My profile </router-link> -->
          <!-- <a class="dropdown-item" href="#" @click="m_notifyVue('top','center','HELLO!!!','red')">Joining an organization</a> -->
          <!-- <div class="dropdown-divider"></div> -->
          <!-- <a class="dropdown-item" @click="a_join_subject()"> Join subject </a> -->
          <!-- <a class="dropdown-item" @click="a_test()"> Test </a> -->
          <!-- <div class="dropdown-divider"></div> -->
          <a class="dropdown-item" @click="a_logout()"> Sign out </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="m_modal_gisaid(true)"> GISAID Credentials </a>
        </drop-down>

        <drop-down v-else icon="far fa-user" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="far fa-user nav-icon"> </i>
            <i class="fas fa-sign-in-alt nav-icon"> </i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <a class="dropdown-item" @click="m_modal_login(true)">Sign in</a>
          <div class="dropdown-divider"></div>
          <!-- <a class="dropdown-item" @click="m_modal_reg(true)">Registration</a> -->
          <!-- <router-link tag="li" class="dropdown-item" to="/registration"> Registration </router-link> -->
          <!-- <a class="dropdown-item" href="/registration">Registration</a> -->
          <!-- <a class="dropdown-item" href="#" @click="m_notifyVue('top','center','HELLO!!!','info')">Registration</a> -->
          <a class="dropdown-item" @click="m_modal_forgot(true)">Forgot your password?</a>
        </drop-down>

        <!-- <li class="nav-item">
          <a class="nav-link btn-rotate" href="#pablo">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li> -->
      </ul>
    </template>
  </navbar>
</template>

<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
  import {Select, Option, Tag } from 'element-ui'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import axios from 'axios';
  import VueNotify from 'vue-notifyjs'
  import VueRouter from 'vue-router'

  export default {
    components: {
      Navbar,
      NavbarToggleButton,
      [Select.name]: Select,
      [Option.name]: Option,
      [Tag.name]: Tag,
    },
    data() {
      return {
        activeNotifications: true,
        showNavbar: false,
        selects: {
            application: '',
            applications: [
              {value: 'Diagnostics', label: 'Diagnostics'},
              {value: 'NGS Browser', label: 'NGS Browser'},
              {value: 'Gen Explorer ', label: 'Gen Explorer'},
            ]
          },
      }
    },

    computed: {
      ...mapState({
        modal_login: state => state.modal_login,
        modal_reg: state => state.modal_reg,
        modal_forgot: state => state.modal_forgot,
        modal_gisaid: state => state.modal_gisaid,
        id_user: state => state.id_user,
        token: state => state.token,
        id_subject: state => state.id_subject,
        user: state => state.user,
        subject: state => state.subject,


      }),

      ...mapGetters({

      }),
    },

    methods: {
      ...mapMutations({
        m_modal_login: 'm_modal_login',
        m_modal_reg: 'm_modal_reg',
        m_modal_forgot: 'm_modal_forgot',
        m_modal_gisaid: 'm_modal_gisaid',
        m_token: 'm_token',
        m_id_user: 'm_id_user',
      }),

      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },

      ...mapActions({
        a_logout: 'a_logout',
        a_test: 'a_test',
        a_join_subject: 'a_join_subject',

      }),


    }
  }

</script>
<style>
.nav-icon{
  font-size: 16px;
  margin-right: 5px;
  color: white;
}

navbar{
  background-color: #333 !important;
}

el-select {
  margin-left: 25px !important;
  margin-right: 25px !important;
}

.select-warning.el-select .el-input input {
  border-radius: 0px !important;
  color: gray !important;
  background-color: white !important;
}

.white {
  color: white !important;
}

.genovesa {
  font-size: 25px !important;
  font-weight: 900 !important;
  text-align: left !important;
  margin-left: 270px !important;
  color: white !important;
}

.genovesa_small {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: rgb(188, 236, 245) !important;
}

.dolu_subject {
  padding-top: 6px !important;
}
</style>
